/**
 * @function to getLimit apis
 * @param var originationIsoCode,destinationIsoCode and limitRequest
 * @returns api return success and error callback for limit response
 */


let getLimitsInFlight = null;

const triggerGetLimits = (originationIsoCode, destinationIsoCode, limitRequest) => {
    const cachedData = getLimitCacheData(destinationIsoCode.country)
    if(cachedData) return cachedData
    if (getLimitsInFlight) {
        return getLimitsInFlight;
    }
    const getLimitUrl = `${limitRequest.host}wudgtsrvs/mobiliser/rest/channel/GwpGetLimits?timestamp=${new Date().getTime()}`; 
    const reqPayload = {
        channel: {
            device_identifier: "RESPONSIVE_WEB",
            is_responsive: "true",
            name: "Western Union",
            type: "WEB",
            version: "9Z00",
        },
        payment_details: {
            origination: {
            currency_iso_code: originationIsoCode.currency, //"USD",
            country_iso_code: originationIsoCode.country.toUpperCase(), //"US",
            },
            destination: {
            currency_iso_code: destinationIsoCode.currency, //"MXN",
            country_iso_code: destinationIsoCode.country.toUpperCase() //"MX",
            },
        },
        external_reference_no: "1",
        security: {
            session: {
            id: limitRequest?.sessionId ? limitRequest?.sessionId : 'web-73f3b8f8-79f3-4dcc-b472-fd5fd0311d59'
            },
            client_ip:  limitRequest?.clientIp ? limitRequest?.clientIp : '003211047057',
            version: "2",
        }
    };
    getLimitsInFlight = fetch(getLimitUrl, {
        "headers":limitRequest.headers,
        "body": JSON.stringify(reqPayload),
        "method": "POST"
    })
    .then((data) => data.json())
    .then((response) => {
        // Store response in sessionStorage for 15 minutes
        sessionStorage.setItem(`${LIMITS_CACHE_KEY}-${destinationIsoCode.country}`, JSON.stringify(response));
        setTimeout(() => sessionStorage.removeItem(`${LIMITS_CACHE_KEY}-${destinationIsoCode.country}`), 15 * 60 * 1000);
        return response;
    })
    .finally(() => {
        getLimitsInFlight = null;
    });
    return getLimitsInFlight;
};

// Helper to build limitRequest
function buildLimitRequest(sessionId, clientIp) {
    return {
        headers: {
            "accept": "application/json, text/plain, */*",
            "Content-Type": "application/json",
            "accept-language": "en-US,en;q=0.9"
        },
        host: window.location.host.includes('www3') ? uatRs2Url : getHttpRequestUrl(`${window.location.origin}/`),
        sessionId,
        clientIp
    };
}

// Helper to handle limit response
function handleLimitResponse(limitResponse, payIn, serviceCode, limitAttribute) {

    if (limitResponse?.error?.code === 'C1561') {
        console.error('error from trigger Limit API ');
        return;
    }
    const transactionLimitsArr = limitResponse?.transaction_limits?.transaction_limit;
    let maxLimitObj = transactionLimitsArr?.reduce((maxObj, curr) => {
        return (Number(curr.max_limit) > Number(maxObj.max_limit)) ? curr : maxObj;
    }, transactionLimitsArr[0]);
    // If serviceCode is blank or null, use the largest max_limit from transaction_limit
    if (!serviceCode && limitResponse?.transaction_limits?.transaction_limit?.length) {
        if (maxLimitObj !== undefined) {
            let sendAmountLimit = Number(maxLimitObj.max_limit) / 100;
            sessionStorage.setItem('sendAmountLimit', sendAmountLimit.toFixed(2));
        }
        return;
    }

    let transactionLimits = limitResponse?.transaction_limits?.pay_in_transaction_limit;


    let amountLimit = transactionLimits.find(pay_in_transaction_limit => (pay_in_transaction_limit.pay_in === CloudPayIn[payIn]) && (pay_in_transaction_limit.service_code === serviceCode)) ||
        transactionLimits.find(pay_in_transaction_limit => (pay_in_transaction_limit.pay_in === CloudPayIn[payIn]))
        || maxLimitObj && {
            limit: maxLimitObj.max_limit
        };
    if (amountLimit !== undefined && amountLimit?.limit) {
        let sendAmountLimit = Number(amountLimit.limit) / 100;
        limitAttribute.setAttribute('data-send-up-to-amount-limit', sendAmountLimit.toFixed(2));
        sessionStorage.setItem('sendAmountLimit', sendAmountLimit.toFixed(2));
    }
}

const getlimitAPI = async (originationIsoCode, destinationIsoCode, serviceCode, payIn, limitAttribute, country, lang) => {
    const { sessionId, clientIp } = getSessionAndClientIpFromCookies();
    if (sessionId && clientIp) {
        const limitRequest = buildLimitRequest(sessionId, clientIp);
        try {
            const limitResponse = await triggerGetLimits(originationIsoCode, destinationIsoCode, limitRequest);
            handleLimitResponse(limitResponse, payIn, serviceCode, limitAttribute);
        } catch (error) {
            console.error('error from trigger Limit API  : ', error);
        }
        return false;
    } else {
        try {
            const response = await createSessionMethod(country, lang, location.host);
            const clientIpResp = response?.security?.client_ip ? response.security.client_ip : '245024209201';
            const sessionIdResp = response?.security?.session.id;
            setCookieOnCreateSessionResponse(response);
            if (clientIpResp && sessionIdResp) {
                const limitRequest = buildLimitRequest(sessionIdResp, clientIpResp);
                try {
                    const limitResponse = await triggerGetLimits(originationIsoCode, destinationIsoCode, limitRequest);
                    handleLimitResponse(limitResponse, payIn, serviceCode, limitAttribute);
                } catch (error) {
                    console.error('error from trigger Limit API  : ', error);
                }
            }
        } catch (e) {
            console.error('error from trigger Session API  : ', e)
        }
        return false;
    }
}